import Alpine from 'alpinejs';
import api, { money, requireAuth } from './api.js';

function createInkoCreationHub() {
  return {
    loading: true,
    meta: null,

    async init() {
      if (!requireAuth()) return;
      try {
        this.meta = await api.meta();
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal memuat INKO CREATION.', 'error');
      } finally {
        this.loading = false;
      }
    },

    money,
  };
}

Alpine.data('inkoCreationHub', createInkoCreationHub);
